import { AddCircleIcon, StyledFlex } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { StyledAddStageLink } from '../../ExtendedDosage.styled';

type AddStageLinksProps = {
   readonly onAddCycle: VoidFunction;
   readonly onAddBreak: VoidFunction;
   readonly breakAppendable: boolean;
};

export const AddStageLinks = (props: AddStageLinksProps): JSX.Element => {
   return (
      <StyledFlex gap={'16px'}>
         <StyledAddStageLink
            testId={'addCycle'}
            icon={<AddCircleIcon />}
            label={prescriptionTranslationKeys.extendedDosage.addCycle}
            onClick={props.onAddCycle}
            block={false}
         />
         <StyledAddStageLink
            testId={'addBreak'}
            icon={<AddCircleIcon />}
            label={prescriptionTranslationKeys.extendedDosage.addBreak}
            onClick={props.onAddBreak}
            disabled={!props.breakAppendable}
            block={false}
         />
      </StyledFlex>
   );
};
